import React from "react";
import { FormFull } from "form-full";
import Styles from "../styles/";
import { Grid } from "@material-ui/core";
import {
  CustomText,
  Input,
  InputAutocomplete,
  InputDate,
} from "../../../components/index";
import { Label } from "../../../components/inputs/Input";
import { fonts, Spacing } from "../../../config";
import { addOneDay } from "../../registerTenant/components/ModalRegistry";
import { masks, validations } from "../../../utils";
import { AccessTime } from "@material-ui/icons";

function Filters({ onSubmit, loading, placeList }) {
  const [formRef, setFormRef] = React.useState<any>(null);
  const [minDate, setMinDate] = React.useState<any>(null);

  return (
    <FormFull formRef={setFormRef} onSubmit={(data) => onSubmit(data)}>
      <Grid alignItems="flex-end" container spacing={1}>
        <Grid item xs={6} md={6} lg={3}>
          <div style={{ paddingTop: "9px" }}>
            <Input name="name" label="Hóspede" placeholder="HÓSPEDE" />
          </div>
        </Grid>
        <Grid container item xs={6} md={6} lg={2}>
          <Label>DATA SOLICITAÇÃO</Label>
          <InputDate
            onChange={(value) => {
              //console.log(value);
            }}
            name="solicitationDate"
          />
        </Grid>
        <Grid container item xs={12} md={12} lg={3} >
          <div style={{ display: "flex" , flexDirection: "row", alignItems: "center" , width: "100%"}}>
            <div style={{ width: "100%"}}>
              <Label>ESTADIA</Label>
              <InputDate
                onChange={(value) => {
                  setMinDate(value);
                  const end = formRef?.getValue("endDate");

                  if (end < value) {
                    formRef?.clearValue("endDate", false);
                  }
                }}
                name="startDate"
              />
            </div>
            <p style={{ padding: "0px 10px"}}>até</p>
            <div style={{ width: "100%", marginTop: "auto" }}>
              <InputDate minDate={addOneDay(minDate)} name="endDate" />
            </div>
          </div>
        </Grid>
        <Grid item xs={6} md={6} lg={2}>
          <div style={{ paddingTop: "9px" }}>
            <Input
              name="nhospedes"
              label="Nº Acompanhantes"
              placeholder="0"
            />
          </div>
        </Grid>
        <Grid item xs={6} md={6} lg={2}>
          <div style={{ paddingTop: "9px" }}>
            <InputAutocomplete
              readOnly={false}
              name="status"
              label="Status"
              options={placeList ? placeList : []}
            />
          </div>
        </Grid>
      </Grid>
      <Styles.ButtonContainer>
        <Styles.Clear
          loading={loading}
          disabled={loading}
          fullWidth={false}
          action="clear"
        >
          Limpar
        </Styles.Clear>
        <Styles.Submit
          loading={loading}
          disabled={loading}
          fullWidth={false}
          action="submit"
        >
          Aplicar Filtros
        </Styles.Submit>
      </Styles.ButtonContainer>
    </FormFull>
  );
}

export default Filters;
